module.exports = __webpack_public_path__ + "media/src/images/about/outline/mypage-af85466108dd0cdba1852bf413fcc1bb.png";